import styled from 'styled-components';

export const LoadingContainer = styled.div`
    width: 100%;
    height: 90%;
    padding: 5% 0 0 5%;
    position: fixed;
    top: 5%;
`;


export const ContactUsRouteContainer = styled.div`
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

export const ContactUsContainer = styled.div`
margin-top: ${window.screen.width <= 1000 ? '12%' : '5%'};
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    

    .about-info {
        text-shadow: black 0px 0px 10px;
        font-size: 20px;
        width: 1200px;
        max-width: 90%;
        // padding: 2rem;
        align-self: center;
        display: flex;
        flex-direction: column;

        .about-heading {
            font-size: 1.2em;
            font-weight: bolder;
            text-decoration: underline;
        }

        h2 {
            font-size: ${window.screen.width <= 1000 ? '45px' : '65px'};
            text-align: center;
        }

        p {
            font-size: ${window.screen.width <= 1000 ? '20px' : '28px'};
            padding: 0 2% 0 2%;
            margin: 10px 4px 10px 4px;
        }
    
        span {
            height: 10px;
        }

        ul{
            font-size: ${window.screen.width <= 1000 ? '20px' : '28px'};
            margin: 0;
            padding-left: 8%;
        }

        .google-form-box {
            width: auto;
            // height: auto;
            // background-color: red;
            // overflow: hidden;

            iframe {
                min-height: 100%;
                overflow: hidden;
                background-color: red;
            }
        }

        button{
            width: auto;
            height: 3em;
            padding: 1.5em;
            margin: 8%;
            font-size: 0.8em;
            background-color: black;
            color: white;
            align-self: center;

            &:hover {
                color: black;
                background-color: whitesmoke;
            }
        }
    }
`;
